export const modelsList = [
  {
    img: "1",
    modelId: "43b3221efe52482da78121cd253bcc11",
    arPlayerId: "43b3221efe52482da78121cd253bcc11",
    name: "Dresser Style 90",
    pdf:"dresser90",
    hasAnnotation: true,
    audio:null,
    animationCollection: {
      cutView: {
        name: "CutView",
        id: "a137f935ea1b4a4f8cc0b12fa771d208",
        lengthAni: 0,
      },
      idle: {
        name: "Idle",
        id: "ae7a6c080b5f4f438126acdd763a5cda",
        lengthAni: 0,
      },
      exploded: {
        name: "Combine",
        id: "f3bb0983af794046aa6317c5939cf8c5",
        lengthAni: 3.96,
      },
      combine: {
        name: "Exploded",
        id: "b9d06177d615497092a6820ab52464f3",
        lengthAni: 3.96,
      },
    },
    position: [-0.09527451388566001, -0.16717567896079966, 0.06587710283781638],
    target: [
      0.00008671846783312572, -0.0037252252106633505, -0.003279400818770054,
    ],
    zoomInPosition: [
      -0.032693104015186665, -0.09211422517537261, 0.018990450560982655,
    ],
    zoomInTarget: [
      0.0030033559329525465, -0.0028691751203826226, -0.0009367268914974185,
    ],
    zoomOutPosition: [
      -0.13063931815225527, -0.29228774071416813, 0.09931660399501427,
    ],
    zoomOutTarget: [
      0.005489932032359897, -0.004124017038556792, -0.006373142656580408,
    ],
  },
  {
    img: "2",
    modelId: "4e96f6bdd2354e78ae0f315ade3974a3",
    arPlayerId: "4e96f6bdd2354e78ae0f315ade3974a3",
    name: "Footage Squeeze Off",
    video:"dkiIKKALSt0?si=Dj1BSL8NLRF8n2pD",
    pdf:"footagesqueezeoff",
    hasAnnotation: true,
    audio:null,
    animationCollection: {
      playAni: {
        name: "FullAnimationState",
        id: "2790dd6842ea4e15bba52de03693561a",
        lengthAni: 2.633,
      },
    },
    position: [-0.3020387442574117, 0.20255008979837605, -0.021686121407845777],
    target: [
      -0.006196551544079977, 0.021138986126793217, -0.022997714087757623,
    ],
    zoomInPosition: [
      -0.15546698180316343, 0.09642717396996028, -0.03110063650143389,
    ],
    zoomInTarget: [
      -0.0014749407411368222, 0.025630242580746, -0.026639118819163334,
    ],
    zoomOutPosition: [
      -0.41267534104702774, 0.2146771980396172, -0.038552577750346095,
    ],
    zoomOutTarget: [
      -0.0014749407411368222, 0.025630242580746, -0.026639118819163334,
    ],
  },
  {
    img: "3",
    modelId: "a90446b3c16f4fdf8ef3e011b2117d67",
    arPlayerId: "a90446b3c16f4fdf8ef3e011b2117d67",
    name: "Floating Ball Valve",
    pdf:"floatingvalve",
    hasAnnotation: true,
    audio:null,
    animationCollection: {
      cutView: {
        name: "CutView",
        id: "f70aef9450874d9d9a3b9582e0812178",
        lengthAni: 2.65,
      },
      idle: {
        name: "Idle",
        id: "d3e3ca0d2ed8462bac117c4510dc249b",
        lengthAni: 0.65,
      },
      combine: {
        name: "Combine",
        id: "f56b1c27c3fd445495edc02443afea55",
        lengthAni: 1.65,
      },
      exploded: {
        name: "Exploded",
        id: "69a5f48556a742f0936cab72ec5fa5c8",
        lengthAni: 1.633,
      },
    },
    position: [-0.09947692375008711, -0.22301261696979027, 0.15303369084496185],
    target: [0.02373102794579557, -0.0036346750937359703, 0.030773394466537884],
    zoomInPosition: [
      -0.05879883943413858, -0.13468446097868564, 0.09796042969569158,
    ],
    zoomInTarget: [
      0.021319519287748324, -0.0015792967475469159, 0.03203126503993047,
    ],
    zoomOutPosition: [
      -0.17597180145175323, -0.3439243997115963, 0.15055561929132777,
    ],
    zoomOutTarget: [
      0.021319519287748324, -0.0015792967475469159, 0.03203126503993047,
    ],
  },
  {
    img: "4",
    modelId: "ea0717e4237843f4ad75df23d2063c46",
    arPlayerId: "ea0717e4237843f4ad75df23d2063c46",
    name: "Pipeline Heater",
    hasAnnotation: false,
    audio:null,
    animationCollection: {
      cutView: {
        name: "CutView",
        id: "093b309e3c2542399367a42dce922fd0",
        lengthAni: 1.633,
      },
      idle: {
        name: "Idle",
        id: "ceff4c0956d04c25ba51940c7b39304e",
        lengthAni: 0,
      },
      playAni: {
        name: "FullAnimationState",
        id: "e061d50fbae946dcb6d71cbd420337a5",
        lengthAni: 14.967,
      },
    },
    position: [3.262691710720205, -0.27348066557329104, 0.8133990843024951],
    target: [0.7248658949342836, -0.20345182540694126, 0.9722273497212767],
    zoomOut: 5,
    zoomInPosition: [1.450937754863352, 0.082928548880141, 0.31597077038331317],
    zoomInTarget: [0.6952322380648382, 0.10378150912647795, 0.363266134649018],
    zoomOutPosition: [
      5.1604723320599275, 0.0402542523901967, 0.9948652061200808,
    ],
    zoomOutTarget: [
      0.6959941250692332, -0.01457075382061224, 0.7310252540277687,
    ],
  },
  {
    img: "5",
    modelId: "4c5c5a14f7014c9981b11cb877bafe25",
    arPlayerId: "99c2f07905af44b88d2f0ab9e58dd2aa",
    name: "Vermeer T-5555",
    video:"vaVcbOKNtXI?si=ZknlIXAIEAspVXqj",
    pdf:"vermeer-track-trencher-t555",
    hasAnnotation: true,
    audio:null,
    animationCollection: {
      playAni: {
        name: "Operation",
        id: "1c6c735f1e2541088b6f61803777ee62",
        lengthAni: 5,
      },
    },
    position: [0.38484670800919546, -3.5543785195847617, 1.2328173433294354],
    target: [-0.05018612962833058, 0.03015555820153798, 0.8558104941081862],
    zoomOut: 5,
    zoomInPosition: [
      -0.16242954673510032, -1.1546320378934087, 0.9001063427317478,
    ],
    zoomInTarget: [0.1558978314527962, 0.04572902898032443, 0.5908910356165858],
    zoomOutPosition: [
      0.16167996838680232, -4.364445875853932, 0.975619571848285,
    ],
    zoomOutTarget: [
      0.15061599481623844, 0.028070010728943454, 0.6042733292449874,
    ],
  },
  {
    img: "6",
    modelId: "1af92b855e344d01b3295ab2d1c84a87",
    arPlayerId: "1af92b855e344d01b3295ab2d1c84a87",
    name: "Traditional Purge",
    hasAnnotation: true,
    audio:'traditionalpurging.mp3',
    animationCollection: {
      playAni: {
        name: "FullAnimationState",
        id: "985ee90e7a164f72b011f8db8e852a92",
        lengthAni: 43.333,
      },
    },
    position: [-0.12202490379843602, -4.693013099231151, 1.108392958332308],
    target: [0.003706348995026072, 0.39628939231594995, 0.9887580502737688],
    zoomOut: 7,
    zoomIn: 0.6,
    zoomInPosition: [
      0.748802791258925, -1.8107842813000985, 1.0891124505618497,
    ],
    zoomInTarget: [0.8028692063784119, 0.37769579078383253, 1.0376675595091822],
    zoomOutPosition: [
      -0.10025166890210839, -5.459319668124828, 1.0732550814871697,
    ],
    zoomOutTarget: [
      0.04435554649710903, 0.3940369578200753, 0.9356594516455854,
    ],
  },
]

export const routeData = [
  {
    electrofusionOptimized: {
      name: "Electrofusion (Optimized)",
      image: "electrofusion",
      description:
        "Ensuring uniform melting for a strong electrofusion joint and the minimisation of welding and cooling times.",
      assetIds: [
        {
          id: "7991f23dfeab472693f81bdb6ea5a5a0",
          name: "Correct",
        },
        {
          id: "719147e5485440af9724238ab8a23f72",
          name: "Misaligned",
        },
        {
          id: "54fbcd55da354fa6898f4279a15aa3e8",
          name: "Scrape",
        },
        {
          id: "20fe852ffc074bfd99fde4837d246f5d",
          name: "Melt Out",
        },
        {
          id: "ef6389ec95ad47ad9036c01f94742d9d",
          name: "Gouge",
        },
      ],
    },
  },
  {
    piconeo3: {
      name: "Pico Neo 3",
      image: "piconeo3",
      description:
        "Pico's Snapdragon XR2 VR headset: 4K display, 6DoF tracking, seamless 2-in-1 switching. Unbox, no extras needed—immerse in VR designed for you.",
      assetId: "af8c26f30a6c42daa436a197cc75a636",
      folderName: "pico",
      numberOfImage: 18,
    },
  },
];

export const videoInfoLink = [
  {
    videoName : "Paracosma 3D Training and Marketing Platform Teaser",
    link:"95n2uFJWwD8?si=KcokFwR0gIchzEBB",
    videiId:"95n2uFJWwD8"
  },
  {
    videoName: "3D Training Library for Natural Gas",
    link: "LdqJ2j77rTw?si=ph3ArYxpbdnoEDaR",
    videiId:"LdqJ2j77rTw"
  },
  {
    videoName: "Paracosma 3D Training Platform Feature Overview",
    link: "hwjZZS7jHaU?si=Cm887MGniEVoddC8",
    videiId:"hwjZZS7jHaU"
  },
  {
    videoName: "What’s a 3D Model Worth?",
    link: "MHwRNirYANs?si=wcstGhhy1pVM3Z_L",
    videiId:"MHwRNirYANs"
  },
  {
    videoName: "PowerView E-Learning Content: 3D Lessons, Quizzes & Gamification",
    link: "kJoltPWS10I?si=_nGimEnX8rONezhZ",
    videiId:"kJoltPWS10I"
  },
  {
    videoName: "PowerView Camera Controls: No-Code Lesson Creation Tool",
    link: "VcqqIPP_y8s?si=bTGNrWS94oI4KAXJ",
    videiId:"VcqqIPP_y8s"
  },
  {
    videoName: "PowerView Instructional Video: Bypass Meter Set",
    link: "QfXqi97U-rI?si=inFtND3ezuQHjqD-",
    videiId:"QfXqi97U-rI"
  },
  {
    videoName: "PowerView 3D UI Explorer: Service Line & Meter Set | Paracosma",
    link: "YjxUftV2qLA?si=XUmFAz9iEXG3sinN",
    videiId:"YjxUftV2qLA"
  },
  {
    videoName: "PowerView Training Library for Natural Gas - 3D Models Teaser | Paracosma",
    link: "hkOaJ7nvfx4?si=pWingpSdRBdH0K_X",
    videiId:"hkOaJ7nvfx4"
  },
  {
    videoName: "PowerView Interactive Training Platform - Admin Tutorial | Paracosma",
    link: "_Uz2I7H5wGk?si=UeAMs7DAmI_LNZOI",
    videiId:"_Uz2I7H5wGk"
  },
];
